import React from 'react';
import {InputAdornment, Slide, TextField} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import { menuStyles } from '../Styles/MenuStyles';
import clsx from 'clsx';
import {useTranslation} from "react-i18next";
import { ILayoutElement } from '../../../_types/interfaces/IRoute';
import MenuElement from './MenuElement';

type MenuProps = {
    isOpen: boolean;
    close: () => void;
    elems: Array<ILayoutElement>
};

export default function Menu(props: MenuProps) {
    const classes = menuStyles();
    const {isOpen, close, elems} = props;
    // const {t} = useTranslation();

    return (
        <Slide direction="right" in={isOpen} mountOnEnter unmountOnExit >
            <aside className={clsx({
                [classes.slide]: true,
                [classes.slideMobile]: window.innerWidth < 1000
            })}>
                <div style={{height: '100%'}}>
                    <div className={classes.topSlide}>
                        <div className={classes.close} onClick={close}>
                            <CloseIcon/>
                        </div>
                        <TextField
                            className={classes.slideTitle}
                            style={{color: '#B0B0B1 !important'}}
                            placeholder={'Фильтр'}
                            color="secondary"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>
                    <div className={classes.slideContent}>
                        <div className={classes.contentGroups}>
                            <div className={classes.groups}>
                                {/* <h5 className={classes.groupTitle}>
                                    {t('title')}
                                </h5> */}
                                <div className={classes.groupContent}>
                                    {
                                        elems.map((element, ind) =>
                                            <MenuElement
                                                key={ind}
                                                link={element.link}
                                                icon={element.icon}
                                                text={element.text}
                                                newTab={element.newTab}
                                                onClick={close}
                                            />
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </aside>
        </Slide>
    );
}
